import { createContext, useContext } from "react";

/**
 * Contexto pra reduzir prop drilling nos componentes extraídos de
 * UserAdminModal.jsx — mesmo padrão de WorkoutAdminContext.js (issue 012,
 * docs/07-issues.md), migração feita um componente por vez.
 *
 * UserAdminModal.jsx continua sendo o dono de todo o estado (useState/
 * useCallback) — esse contexto só evita ter que listar dezenas de props
 * manualmente em cada <Componente ... /> e na assinatura de cada função.
 * Cada componente migrado usa useUserAdminContext() e desestrutura só o
 * que precisa, em vez de receber tudo via props.
 *
 * Sem valor default proposital (null): usar o hook fora de um Provider é
 * bug de wiring, não estado válido — por isso o hook lança erro nesse caso,
 * em vez de silenciosamente deixar handlers undefined.
 */
export const UserAdminContext = createContext(null);

export function useUserAdminContext() {
  const ctx = useContext(UserAdminContext);
  if (!ctx) {
    throw new Error(
      "useUserAdminContext precisa ser usado dentro de <UserAdminContext.Provider>."
    );
  }
  return ctx;
}
